<div class="container-fluid">
  <div class="conteudo">
    <div *ngIf="welcomeMessage" class="container-first">
      <div class="logo">
        <img src="assets/img/logo_only_tv_package_page2.png" alt="">
      </div>
      <h1>{{ welcomeMessage }}</h1>
    </div>
    <div *ngIf="!welcomeMessage" class="container-preview">
      <!-- Current Channel -->
      <div *ngIf="currentChannel" class="row">
        <div class="video-preview">
          <img class="rounded d-block" [src]="currentChannel.CurrentProgram?.ThumbnailUrl" alt="">
        </div>
        <div class="info-preview">
          <div class="noar d-flex align-items-center justify-content-evenly">
            <div>NO AR</div>
            <svg height="10" width="10">
              <circle cx="5" cy="5" r="5" stroke-width="3" fill="white" />
            </svg>
          </div>
          <div class="title-preview">{{ currentChannel.CurrentProgram?.Title }}</div>
          <div class="program-time">{{currentChannel.CurrentProgram?.StartTime | date : 'shortTime' : '' : 'pt-BR'}} - {{ currentChannel.CurrentProgram?.EndTime | date : 'shortTime' : '' : 'pt-BR' }} </div>
          <div class="program-description" [innerHTML]="currentChannel.CurrentProgram?.Description"></div>
        </div>
        <div class="logo">
          <img class="rounded mx-auto d-block" src="assets/img/logo_only_tv_package_page_app4.png">
        </div>
      </div>
    </div>
  </div>
  <div class="channels">
    <div class="align-content-between d-flex flex-wrap justify-content-between">
      <ng-container *ngFor="let channel of channels; let i = index">
        <div [ngClass]="{'selected': selectedIndex === i}" class="channel">
          <div class="img-channel"><img [src]="channel.Logo?.PublicUrl"></div>
        </div>
      </ng-container>
    </div>
    <div class="row mt-2">
      <div class="d-flex justify-content-end">
        <div class="me-auto pt-4 text-secondary">{{ version }}</div>
        <div class="d-flex mt-2">
          <div class="arrow up"></div>
          <div class="arrow down"></div>
          <div class="arrow left"></div>
          <div class="arrow right"></div>
          <div class="mx-2">USE AS SETAS PARA MUDAR DE CANAL</div>
        </div>
        <div class="b-info d-flex align-items-center justify-content-end">
          <div class="circle-ok">OK</div>
          <div> PARA ASSISTIR</div>
        </div>
      </div>
    </div>
  </div>
</div>
